module.exports = __webpack_public_path__ + "static/media/notification.5bee74ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/notification.svg
// module id = 154
// module chunks = 0